import { ArrowRightOutlined } from '@ant-design/icons';
import { type VoceGuidaCompilazioneDTOTesto } from '@framework/api-client/api/inquiries/schemas/voceGuidaCompilazioneDTOTesto.ts';
import { CompilationContainer } from '@framework/frontoffice-submission/burden/CompilationContainer.tsx';
import { SubmissionCancelButton } from '@framework/frontoffice-submission/navigation/buttons/SubmissionCancelButton.tsx';
import { CardFooterButtons } from '@framework/frontoffice-submission/navigation/CardFooterButtons.tsx';
import { type ISubmissionNavigator } from '@framework/frontoffice-submission/navigation/useSubmissionNavigation.ts';
import { SubmissionMenuKey } from '@framework/frontoffice-submission/submission/hooks/SubmissionMenuKey.ts';
import { useSubmission } from '@framework/frontoffice-submission/submission/hooks/useSubmission.ts';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { useIdFromUrl } from '@framework/ui/hooks/useIdFromUrl.ts';
import { Button, Space } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type RouteComponentProps } from 'react-router';
import { NetworkAlertPage } from '../../../../routes/errors/network-alert/NetworkAlertPage.tsx';
import { GuideTextStyled } from './GuideTextStyled.tsx';

interface Params {
  id: string;
}

export interface ICompilationGuideCardProps
  extends RouteComponentProps<Params> {
  handleNavigation: ISubmissionNavigator;
}

export function CompilationGuideCard(props: ICompilationGuideCardProps) {
  const { handleNavigation } = props;
  const [submissionId] = useIdFromUrl(props, 'id');
  const { t } = useTranslation();

  const { inquiry } = useSubmission(submissionId);

  const guideText = useMemo(() => {
    return inquiry?.vociGuida ?? [];
  }, [inquiry?.vociGuida]);

  if (!inquiry) {
    return (
      <NetworkAlertPage
        noLayout
        message={t(
          'compilation-guide.impossibile-caricare-la-guida-alla-compilazione',
          'Impossibile caricare la guida alla compilazione della domanda',
        )}
        error={t(
          'compilation-guide.domanda-non-trovata-in-archivio',
          `Domanda non trovata in archivio: id {{submissionId}}`,
          { submissionId: submissionId ?? '' },
        )}
      />
    );
  }

  return (
    <>
      <CompilationContainer>
        {guideText?.map((voceGuida, index) => (
          <GuideTextStyled
            key={voceGuida.id ?? `guide-text-${index}`}
            text={voceGuida.testo as VoceGuidaCompilazioneDTOTesto[]}
          />
        ))}
      </CompilationContainer>
      <CardFooterButtons>
        <FlexRow
          right={
            <Space>
              <SubmissionCancelButton />
              <Button
                size="large"
                type="primary"
                onClick={() => {
                  handleNavigation.navigate(SubmissionMenuKey.Guide, 'next');
                }}
              >
                {t('compilation-guide.avvia', 'Avvia')}{' '}
                <ArrowRightOutlined aria-hidden />
              </Button>
            </Space>
          }
        />
      </CardFooterButtons>
    </>
  );
}
